import { getCopierInfoExcludeStatusClose, getMoreInfoFollowers, getPortfoliosPrivate, getPortfoliosSelfTotal } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import ButtonElement from '@/views/elements/button/ButtonElement';
import IconButtonElement from '@/views/elements/iconButton/IconButtonElement';
import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Grid from '@mui/material/Grid2';
import classNames from 'classnames/bind';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import GridCardInfo from '../../ShareMasterFollower/GridCardInfo';
import DeleteAccount from '../DeleteAccount/DeleteAccount';
import ExtendInvest from '../ExtendInvest/ExtendInvest';
import StopCopy from '../StopCopy/StopCopy';


import { formatDate, getFirstCharacterName, getScrollTop, scrollToTop } from '@/utilities';
import ViewNumberFormat from '@/views/elements/Inputs/ViewNumberFormat';
import { Avatar, FormControl, Menu, MenuItem, Select, SelectChangeEvent, useTheme, Box, Stack } from '@mui/material';
import InvestmentEfficiencyChart from '../../ShareMasterFollower/Charts/InvestmentEfficiencyChart';
import ProfitLossHistoryChart from '../../ShareMasterFollower/Charts/ProfitLossHistoryChart';
import ConfigCopy from '../ConfigCopy/ConfigCopy';
import styles from './PortfolioCopies.module.scss';
import SharedStateBusInstance from '@/componentShare/SharedStateBus';
import { isEmpty } from 'lodash';
import Withdraw from '../Withdraw/Withdraw';
import { EventShared, ScopeShared } from '@/componentShare/constant';
import AllocationCategoryChartRealtime from '../../ShareMasterFollower/Charts/AllocationCategoryChartRealtime';
import { registerTopics, socketRoomName, unregisterCallerId } from '@/stores/dataManager/socketServices/socketService';
import Random from '@/utilities/random';
import { getInstrumentsBySymbolsAction } from '@/stores/dataManager/Actions/symbolsAction';
import HoldingsListSymbolRealtime from '../../ShareMasterFollower/HoldingsListSymbolRealtime/HoldingsListSymbolRealtime';
import InvestmentZoningChart from '../../ShareMasterFollower/Charts/InvestmentZoningChart';
import SellStuckStocks from '../SellStuckStocks/SellStuckStocks';
import SellOddLotStocks from '../SellOddLotStocks/SellOddLotStocks';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useCosInfo } from '@/controllers/gridManager/accountsManager/accountManager';
import HeaderDataFollower from '../../ShareMasterFollower/HeaderDataFollower';
import { useTranslation } from 'react-i18next';
import { COS_ROLE, STATUS_ACCOUNT } from '@/stores/dataStore/memoryStore/const/constIndex';
import useIsMobile from '@/componentShare/hooks/useIsMobile';
import RenderProfitLoss from '../../ShareMasterFollower/RenderProfitLoss';
const cx = classNames.bind(styles);

type Props = {}

export type TimeRanges = '1-M' | '3-M' | '6-M' | '1-Y'

const callerId = Random.randomComponentId()

export default function PortfolioCopies({ }: Props) {
    const theme = useTheme()
    const { t } = useTranslation()

    const { cosInfo } = useCosInfo()
    const { refaccount, cosrole, status: accountStatus } = cosInfo

    const currentMainScrollTop = useRef<number>(0)
    const [openModalCopyExtend, setOpenModalCopyExtend] = useState<boolean>(false)
    const [openModalStopCopy, setOpenModalStopCopy] = useState<boolean>(false)
    const [openModalDelete, setOpenModalDelete] = useState<boolean>(false)
    const [openModalConfig, setOpenModalConfig] = useState<boolean>(false)
    const [openModalWithdraw, setOpenModalWithdraw] = useState<boolean>(false)
    const [openModalSellStuckStocks, setOpenModalSellStuckStocks] = useState<boolean>(false)
    const [openModalSellOddLotStocks, setOpenModalSellOddLotStocks] = useState<boolean>(false)


    const [openViewMaster, setOpenViewMaster] = useState<boolean>(false)

    const [dataMasterTrade, setDataMasterTrade] = useState<any>({})
    const [currentMasterAccount, setCurrentMasterAccount] = useState<string>('')

    const [infoFollower, setInfoFollower] = useState<any>({})

    const [openPopper, setOpenPopper] = useState<boolean>(false)
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const [dataSeriesIZ, setDataSeriesIZ] = useState<any[]>([])

    const [dataPortfolios, setDataPortfolios] = useState<any[]>([])
    const [isDataReady, setIsDataReady] = useState<boolean>(false)

    const [dataPortfoliosTotal, setDataPortfoliosTotal] = useState<any[]>([])
    const [isDataTotalReady, setIsDataTotalReady] = useState<boolean>(false)

    const [listMasterCopy, setListMasterCopy] = useState<[]>([])
    const [reloadValue, setReloadValue] = useState<number>(0)

    const matches = useIsMobile()
    const isMasterWaitStopCopy = dataMasterTrade?.flstatus === STATUS_ACCOUNT.WC

    const [pageSize, setPageSize] = useState<number>(20)
    const [total, setTotal] = useState<number>(0)
    const [pageIndex, setPageIndex] = useState<number>(1)

    const handleChangePage = (
        _event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        const nPage = newPage + 1
        // console.log('ha_check_newPage', nPage);
        setPageIndex(nPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setPageSize(parseInt(event.target.value, 10));
        setPageIndex(1);
    };

    const registerSymbolTopicsSymbol = (listSymbols: any[]) => {
        const topics = listSymbols.map((symbol: any) => {
            return socketRoomName.instrument + ':' + symbol;
        });
        registerTopics(topics, callerId);
    }

    const triggerReload = async () => {
        setReloadValue(prevCount => prevCount + 1)
    }

    useEffect(() => {
        async function getDataPortfolios(accountId: string, masterAccount: string) {
            const { isSuccess, data } = await getPortfoliosPrivate(
                accountId,
                masterAccount,
                1,
                9999
            )
            if (isSuccess) {
                // console.log('ha_check_datagetDataPortfolios', data)
                const listSymbols = data.filter((item: any) => item.symbol !== 'Tiền').map((item: any) => item.symbol)
                registerSymbolTopicsSymbol(listSymbols)
                if (listSymbols && listSymbols.length !== 0) {
                    const instruments = await getInstrumentsBySymbolsAction({ symbols: listSymbols })
                    if (instruments && instruments.length !== 0) {
                        const reWriteMarketPrice = data.map((item: any) => {
                            const findInstrument = instruments.find((instrument: any) => item.symbol === instrument.symbol)
                            // console.log('ha_check_findInstrument', findInstrument)
                            return { ...item, marketprice: findInstrument?.closePrice === 0 ? item.marketprice : findInstrument?.closePrice ?? item.marketprice }
                        })
                        setDataPortfolios(reWriteMarketPrice)
                        setIsDataReady(true)
                    } else {
                        setDataPortfolios(data)
                        setIsDataReady(true)
                    }
                } else {
                    setDataPortfolios(data)
                    setIsDataReady(true)
                }
            }
        }

        if (openViewMaster) {
            unregisterCallerId(callerId);
            setIsDataReady(false)
            getDataPortfolios(refaccount, masterAccount)
        }

        return () => {
            unregisterCallerId(callerId);
        }


    }, [openViewMaster, dataMasterTrade, reloadValue])

    useEffect(() => {
        async function getDataPortfoliosTotal(accountId: string) {
            const { isSuccess, data } = await getPortfoliosSelfTotal(
                accountId,
                '', // ALL
                1,
                9999
            )
            if (isSuccess) {
                const listSymbols = data.filter((item: any) => item.symbol !== 'Tiền').map((item: any) => item.symbol)
                registerSymbolTopicsSymbol(listSymbols)
                if (listSymbols && listSymbols.length !== 0) {
                    const instruments = await getInstrumentsBySymbolsAction({ symbols: listSymbols })
                    if (instruments && instruments.length !== 0) {
                        const reWriteMarketPrice = data.map((item: any) => {
                            const findInstrument = instruments.find((instrument: any) => item.symbol === instrument.symbol)
                            // console.log('ha_check_findInstrument', findInstrument)
                            return { ...item, marketprice: findInstrument?.closePrice === 0 ? item.marketprice : findInstrument?.closePrice ?? item.marketprice }
                        })
                        setDataPortfoliosTotal(reWriteMarketPrice)
                        setIsDataTotalReady(true)
                    } else {
                        setDataPortfoliosTotal(data)
                        setIsDataTotalReady(true)
                    }
                } else {
                    setDataPortfoliosTotal(data)
                    setIsDataTotalReady(true)
                }
            }
        }

        if (openViewMaster === false) {
            unregisterCallerId(callerId);
            setIsDataTotalReady(false)
            getDataPortfoliosTotal(refaccount)
        }

        return () => {
            unregisterCallerId(callerId);
        }


    }, [openViewMaster])

    useEffect(() => {
        // hardcode
        async function callApiCopierInfo(accountId: string) {
            const { isSuccess, data } = await getCopierInfoExcludeStatusClose({
                accountId: accountId
                , masterAccount: '' // get all
            })
            if (isSuccess) {
                setListMasterCopy(data)
            }
        }

        if (refaccount) {
            callApiCopierInfo(refaccount)
        }
    }, [refaccount, reloadValue])

    useEffect(() => {
        // console.log('ha_check_rerender', { listMasterCopy, infoFollower })
        if (listMasterCopy.length > 0 && !isEmpty(infoFollower)) {
            const { total_invest } = infoFollower
            const filterEmpty = listMasterCopy.filter((item: any) => {
                return (item?.invest_balance && item?.invest_balance !== 0)
            })

            const data4Chart = filterEmpty.map((item: any) => {
                return {
                    name: item?.fullname ?? '',
                    value: (item?.invest_balance === 0 ? 1 : (item?.invest_balance ?? 1)) / (total_invest ?? 1)
                }
            })
            setDataSeriesIZ(data4Chart)
        }

    }, [listMasterCopy, infoFollower?.total_invest])

    useEffect(() => {
        async function callApiGetMoreInfoFollowers(accountId: string) {
            const { isSuccess, data } = await getMoreInfoFollowers({ accountId, masterAccount: dataMasterTrade?.afacctno ?? '' })
            if (isSuccess === true) {
                setInfoFollower(data)
            }
        }
        if (refaccount) {
            callApiGetMoreInfoFollowers(refaccount)
        }
    }, [refaccount, dataMasterTrade])

    const wrapperSetOpenViewMaster = (status: boolean) => {
        if (status === true) {
            currentMainScrollTop.current = getScrollTop()
            setDataPortfoliosTotal([])
        }
        setOpenViewMaster(status)
    }

    useEffect(() => {
        if (openViewMaster === true) {
            scrollToTop()
        } else {
            scrollToTop('', currentMainScrollTop.current)
        }
    }, [openViewMaster])

    const safePage = (index: number) => {
        return (index - 1) < 0 ? 0 : (index - 1)
    }

    const handleCloseModalCopyExtend = () => {
        setOpenModalCopyExtend(false)
        if (openViewMaster !== true) {
            setDataMasterTrade({})
        }
    }

    const handleExtend = (data: any) => {
        setDataMasterTrade(data)
        setOpenModalCopyExtend(true)
    }

    const handleStop = (data: any) => {
        setDataMasterTrade(data)
        setOpenModalStopCopy(true)
    }

    const handleCloseModalStopCopy = () => {
        setOpenModalStopCopy(false)
        if (openViewMaster !== true) {
            setDataMasterTrade({})
        }
    }

    const handleCloseModalDelete = () => {
        setOpenModalDelete(false)
    }

    const handleOnDeleteAccount = () => {
        setOpenModalDelete(true)
    }

    const handleOpenModalConfig = (data?: any) => {
        // setDataMasterTrade(data)
        setOpenModalConfig(true)
    }

    const handleCloseModalConfig = () => {
        setOpenModalConfig(false)
    }


    const handleCloseViewData = () => {
        wrapperSetOpenViewMaster(false)
        setDataMasterTrade({})
        setDataPortfolios([])
        setIsDataReady(false)
        unregisterCallerId(callerId);
    }

    const handleSetDataMasterTradeAndSelectMaster = (info: any) => {
        setDataMasterTrade(info)
        setCurrentMasterAccount(`${info?.custodycd}`)
    }

    const handleChangeCurrentMasterAccount = (event: SelectChangeEvent) => {
        const value = event.target.value ?? ''
        setCurrentMasterAccount(event.target.value);
        if (value) {
            const data = listMasterCopy.find((item: any) => item.custodycd === value)
            setDataMasterTrade(data ?? {})
        }
    };

    const handleCloseSetting = () => {
        setAnchorEl(null);
        setOpenPopper(false);
    }

    const handleMenuActionView = ((e: any, option: 'CONFIG' | 'SELL_STUCK' | 'SELL_ODD_LOT') => {
        e.stopPropagation();

        if (isMasterWaitStopCopy && option === 'CONFIG') {
            return
        }

        setOpenPopper(false)
        setAnchorEl(null)

        if (option === 'CONFIG') {
            handleOpenModalConfig();
        } else if (option === 'SELL_STUCK') {
            handleSellStuckStocks()
        } else if (option === 'SELL_ODD_LOT') {
            handleSellOddLotStocks()
        }

        // onSelected && onSelected(true)
        // setDataSelected && setDataSelected(info)
    })

    const handleClickSetting = (event: any) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleWithdraw = (data?: any) => {
        setDataMasterTrade(data)
        setOpenModalWithdraw(true)
    }

    const handleCloseModalWithdraw = () => {
        setOpenModalWithdraw(false)
    }

    const handleSellStuckStocks = (data?: any) => {
        setOpenModalSellStuckStocks(true)
    }

    const handleCloseModalSellStuckStocks = () => {
        setOpenModalSellStuckStocks(false)
    }

    const handleSellOddLotStocks = (data?: any) => {
        setOpenModalSellOddLotStocks(true)
    }

    const handleCloseModalSellOddLotStocks = () => {
        setOpenModalSellOddLotStocks(false)
    }

    const masterAccount = dataMasterTrade?.afacctno ?? ''

    const disabledByStatusFollower = useMemo(() => {
        return (cosrole === COS_ROLE.F) && (accountStatus === STATUS_ACCOUNT.WC)
    }, [cosrole, accountStatus])

    const renderInvestmentZoningChartMemo = useMemo(() => {
        return <InvestmentZoningChart
            dataSeries={dataSeriesIZ}
            fullWidth={matches}
        />
    }, [dataSeriesIZ, matches])


    const renderGridCardInfoMemo = useMemo(() => {
        return <GridCardInfo data={listMasterCopy}
            status={true}
            isPrivate={true}
            onExtend={handleExtend}
            onStop={handleStop}
            onWithdraw={handleWithdraw}
            onConfig={handleOpenModalConfig}
            onSellStuck={handleSellStuckStocks}
            onSellOddLot={handleSellOddLotStocks}

            dataSelected={dataMasterTrade}
            setDataSelected={handleSetDataMasterTradeAndSelectMaster}
            onSelected={wrapperSetOpenViewMaster}
        />
    }, [listMasterCopy])


    return (
        <>
            <div className={cx("header-portfolio-viewer")}>
                <div className={cx("main-title")}>
                    <TypographyElement ColorElement="secondary" FontSizeElement="12px" FontWeightElement={500} lineHeight={"18px"}>
                        {t("copytrade.common.copytrading")}
                    </TypographyElement>
                </div>

                <div className={cx("title")}>
                    <TypographyElement FontSizeElement="18px" FontWeightElement={700} lineHeight={"27px"}>
                        {t("copytrade.portfolioCopies.title")}
                    </TypographyElement>
                </div>

                <HeaderDataFollower
                    info={infoFollower}
                    onDelete={handleOnDeleteAccount}
                />

                {
                    openModalStopCopy === true && <StopCopy
                        open={openModalStopCopy}
                        handleClose={handleCloseModalStopCopy}
                        title={''}
                        data={{ dataMasterTrade }}
                    />
                }
            </div>

            <div className={openViewMaster === true ? cx("body-portfolio-viewer", "hidden-visibility") : cx("body-portfolio-viewer")} >
                <div className={matches ? cx("chart", "mobile") : cx("chart")}>
                    {/* <InvestmentZoningChart
                        dataSeries={dataSeriesIZ}
                    /> */}
                    {renderInvestmentZoningChartMemo}

                    {
                        matches ? <Box sx={{ height: "390px", width: "100%" }} >
                            <HoldingsListSymbolRealtime
                                dataReady={isDataTotalReady}
                                dataRaw={dataPortfoliosTotal}
                                statusMaster={''}
                                fullWidth={matches ? true : false}
                            />
                        </Box> : <HoldingsListSymbolRealtime
                            dataReady={isDataTotalReady}
                            dataRaw={dataPortfoliosTotal}
                            statusMaster={''}
                            fullWidth={matches ? true : false}
                        />
                    }

                </div>

                <div className={cx("list-follower")}>

                    <div className={cx("title")}>
                        <TypographyElement FontSizeElement="16px" FontWeightElement={700} >
                            {t("copytrade.portfolioCopies.listFollower")}
                        </TypographyElement>
                    </div>

                    <div className={cx("grid-list-master")}>
                        <Box>
                            {renderGridCardInfoMemo}
                            {/* <GridCardInfo data={listMasterCopy}
                                status={true}
                                isPrivate={true}
                                onExtend={handleExtend}
                                onStop={handleStop}
                                onWithdraw={handleWithdraw}
                                onConfig={handleOpenModalConfig}
                                onSellStuck={handleSellStuckStocks}
                                onSellOddLot={handleSellOddLotStocks}

                                dataSelected={dataMasterTrade}
                                setDataSelected={handleSetDataMasterTradeAndSelectMaster}
                                onSelected={setOpenViewMaster}
                            /> */}
                        </Box>
                    </div>
                    {/* <PaginationElement
                        component="div"
                        count={total}
                        page={safePage(pageIndex)}
                        onPageChange={handleChangePage}
                        rowsPerPage={pageSize}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
                    {
                        openModalCopyExtend === true && <ExtendInvest
                            open={openModalCopyExtend}
                            handleClose={handleCloseModalCopyExtend}
                            title={''}
                            data={{ dataMasterTrade, infoFollower }}
                            triggerReload={triggerReload}
                        />
                    }

                    {
                        openModalDelete === true && <DeleteAccount
                            open={openModalDelete}
                            handleClose={handleCloseModalDelete}
                            title={''}
                            data={{ dataMasterTrade }}
                        />
                    }

                    {
                        openModalWithdraw === true && <Withdraw
                            open={openModalWithdraw}
                            handleClose={handleCloseModalWithdraw}
                            title={''}
                            data={{ dataMasterTrade }}
                            triggerReload={triggerReload}
                        />
                    }


                    {
                        openModalSellStuckStocks === true && <SellStuckStocks
                            open={openModalSellStuckStocks}
                            handleClose={handleCloseModalSellStuckStocks}
                            title={''}
                            data={{ dataMasterTrade }}
                        />
                    }

                    {
                        openModalSellOddLotStocks === true && <SellOddLotStocks
                            open={openModalSellOddLotStocks}
                            handleClose={handleCloseModalSellOddLotStocks}
                            title={''}
                            data={{ dataMasterTrade }}
                        />
                    }

                </div>


            </div >


            {
                openViewMaster === true && <div className={cx("body-portfolio-master-viewer")} >
                    <div className={matches ? cx("viewer-master-header", "mobile") : cx("viewer-master-header")}>
                        <div className={cx("title")}>
                            <TypographyElement ColorElement='primary' FontSizeElement='18px' FontWeightElement={700}>
                                {t("copytrade.portfolioCopies.portfolioDependMaster")}
                            </TypographyElement>
                        </div>

                        <div className={cx("list-action")}>
                            <ButtonElement disabled={disabledByStatusFollower || isMasterWaitStopCopy} onClick={() => handleWithdraw(dataMasterTrade)} customType='Secondary'>
                                {t("copytrade.common.withDraw")}
                            </ButtonElement>

                            <ButtonElement disabled={disabledByStatusFollower || isMasterWaitStopCopy} onClick={() => handleStop(dataMasterTrade)} customType='Secondary'>
                                {t("copytrade.common.stopCopy")}
                            </ButtonElement>

                            <ButtonElement disabled={disabledByStatusFollower || isMasterWaitStopCopy} onClick={() => handleExtend(dataMasterTrade)}>
                                {t("copytrade.common.extendInvest")}
                            </ButtonElement>

                            <ButtonElement onClick={() => {
                                SharedStateBusInstance.emit(EventShared.HOST_REDIRECT_DETAIL_MASTER, ScopeShared.MF, { data: dataMasterTrade })
                            }}>
                                {t("copytrade.portfolioCopies.viewMaster")}
                            </ButtonElement>

                            <IconButtonElement disabled={disabledByStatusFollower} onClick={(e) => handleClickSetting(e)} customType='Secondary'>
                                <MoreVertIcon />
                            </IconButtonElement>
                            <IconButtonElement onClick={() => handleCloseViewData()} customType='Secondary'>
                                <CloseIcon />
                            </IconButtonElement>

                        </div>
                        <Menu
                            slotProps={{
                                paper: {
                                    sx: {
                                        mt: 2,
                                        backgroundColor: theme.palette.background.menu
                                    }
                                }
                            }}
                            elevation={0}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 36,
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={openPopper}
                            onClose={handleCloseSetting}
                        >
                            <MenuItem disabled={isMasterWaitStopCopy} onClick={(e) => handleMenuActionView(e, 'CONFIG')} >{t("copytrade.common.configCopy")}</MenuItem>
                            <MenuItem onClick={(e) => handleMenuActionView(e, 'SELL_STUCK')} >{t("copytrade.common.sellStuck")}</MenuItem>
                            <MenuItem onClick={(e) => handleMenuActionView(e, 'SELL_ODD_LOT')} >{t("copytrade.common.sellOddLot")}</MenuItem>
                        </Menu>
                    </div>

                    <div className={matches ? cx("select-and-info-master", "mobile") : cx("select-and-info-master")}>
                        <FormControl fullWidth={matches ? true : false} >
                            <Select
                                id="select-master"
                                value={currentMasterAccount}
                                size='small'
                                label="currentAccountId"
                                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                                onChange={handleChangeCurrentMasterAccount}
                            >
                                {
                                    listMasterCopy.map((master: any, index: number) => {
                                        return (
                                            <MenuItem
                                                value={`${master?.custodycd}`}
                                                key={index} >
                                                <Stack direction={'row'} spacing={2} sx={{ width: "30%" }}>
                                                    <Avatar sx={{}} aria-label="recipe" variant="rounded">
                                                        {getFirstCharacterName(master?.mt_fullname)}
                                                    </Avatar>
                                                    <Stack direction={'column'} >
                                                        <Box>
                                                            <TypographyElement ColorElement='primary' FontSizeElement='16px' FontWeightElement={700}>
                                                                {master?.mt_fullname}
                                                            </TypographyElement>
                                                        </Box>

                                                        <Box sx={{ color: "text.secondary" }}>
                                                            <TypographyElement ColorElement='secondary' FontSizeElement='14px' FontWeightElement={400}>{t("copytrade.portfolioCopies.dateCopy")} {formatDate(master?.start_date)}</TypographyElement>
                                                        </Box>
                                                    </Stack>
                                                </Stack>
                                            </MenuItem>
                                        )
                                    })
                                }

                            </Select>
                        </FormControl>

                        <Box sx={{ borderRight: "1px solid ", height: 25, mx: "20px", borderColor: 'text.secondary', visibility: matches ? "hidden" : "visible" }}></Box>

                        <Stack direction={matches ? "column" : "row"} spacing={"30px"} justifyContent={'space-around'} alignItems={'flex-start'}>
                            <Stack direction={"column"} spacing={"10px"} justifyContent={'space-around'} alignItems={'flex-start'}>
                                <Stack direction={"row"} spacing={0} justifyContent={'space-around'} alignItems={'flex-start'}>
                                    <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="secondary" component={'span'}>
                                        {t("copytrade.portfolioCopies.bonusFee")}
                                    </TypographyElement>&nbsp;&nbsp;
                                    <ViewNumberFormat displayType='text' value={dataMasterTrade?.bonus_fee} isPercentage={true} />
                                </Stack>
                                <Stack direction={"row"} spacing={0} justifyContent={'space-around'} alignItems={'flex-start'}>
                                    <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="secondary" component={'span'}>
                                        {t("copytrade.headerDataFollower.effective1m")}
                                    </TypographyElement>&nbsp;&nbsp;
                                    <RenderProfitLoss fontSizeElement='14px' fontWeightElement={500} data={dataMasterTrade?.r_1_mon ?? 0} />
                                </Stack>
                            </Stack>

                            <Stack direction={"column"} spacing={"10px"} justifyContent={'space-around'} alignItems={'flex-start'}>
                                <Stack direction={"row"} spacing={0} justifyContent={'space-around'} alignItems={'flex-start'}>
                                    <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="secondary" component={'span'}>
                                        {t("copytrade.portfolioCopies.capital")}
                                    </TypographyElement>&nbsp;&nbsp;
                                    <ViewNumberFormat displayType='text' value={dataMasterTrade?.invest_balance} />
                                </Stack>
                                <Stack direction={"row"} spacing={0} justifyContent={'space-around'} alignItems={'flex-start'}>
                                    <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="secondary" component={'span'}>
                                        {t("copytrade.headerDataFollower.effective3m")}
                                    </TypographyElement>&nbsp;&nbsp;
                                    <RenderProfitLoss fontSizeElement='14px' fontWeightElement={500} data={dataMasterTrade?.r_3_mon ?? 0} />
                                </Stack>
                            </Stack>


                            <Stack direction={"column"} spacing={"10px"} justifyContent={'space-around'} alignItems={'flex-start'}>
                                <Stack direction={"row"} spacing={0} justifyContent={'space-around'} alignItems={'flex-start'}>
                                    <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="secondary" component={'span'}>
                                        {t("copytrade.portfolioCopies.ppnl")}
                                    </TypographyElement>&nbsp;&nbsp;
                                    <ViewNumberFormat displayType='text' value={dataMasterTrade?.pnl} isPercentage={true} isCheckPNL={true} />
                                </Stack>
                                <Stack direction={"row"} spacing={0} justifyContent={'space-around'} alignItems={'flex-start'}>
                                    <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="secondary" component={'span'}>
                                        {t("copytrade.headerDataFollower.effective6m")}
                                    </TypographyElement>&nbsp;&nbsp;
                                    <RenderProfitLoss fontSizeElement='14px' fontWeightElement={500} data={dataMasterTrade?.r_6_mon ?? 0} />
                                </Stack>
                            </Stack>


                            <Stack direction={"column"} spacing={"10px"} justifyContent={'space-around'} alignItems={'flex-start'}>
                                <Stack direction={"row"} spacing={0} justifyContent={'space-around'} alignItems={'flex-start'}>
                                    <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="secondary" component={'span'}>
                                        {t("copytrade.portfolioCopies.navCopy")}
                                    </TypographyElement>&nbsp;&nbsp;
                                    <ViewNumberFormat displayType='text' value={dataMasterTrade?.nav_realtime} />
                                </Stack>

                                <Stack direction={"row"} spacing={0} justifyContent={'space-around'} alignItems={'flex-start'}>
                                    <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="secondary" component={'span'}>
                                        {t("copytrade.headerDataFollower.effectiveAll")}
                                    </TypographyElement>&nbsp;&nbsp;
                                    <RenderProfitLoss fontSizeElement='14px' fontWeightElement={500} data={dataMasterTrade?.accruated_gain_percent ?? 0} />
                                </Stack>
                            </Stack>


                            <Stack direction={"column"} spacing={"10px"} justifyContent={'space-around'} alignItems={'flex-start'}>
                                <Stack direction={"row"} spacing={0} justifyContent={'space-around'} alignItems={'flex-start'}>
                                    <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="secondary" component={'span'}>
                                        {t("copytrade.portfolioCopies.tpsl")}
                                    </TypographyElement>&nbsp;&nbsp;
                                    <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="up" component={'span'}>{dataMasterTrade?.cut_profit_amount}%</TypographyElement>/
                                    <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="down" component={'span'}>{dataMasterTrade?.cut_loss_amount}%</TypographyElement>
                                </Stack>

                            </Stack>
                        </Stack>

                    </div>

                    <div className="viewer-master-body">

                        <Grid container spacing={3} columns={{ xs: 6, sm: 6, md: 6, lg: 12 }} >
                            <Grid size={6} height={"390px"}>

                                <AllocationCategoryChartRealtime
                                    dataSeries={dataPortfolios}
                                    dataReady={isDataReady}
                                />
                            </Grid>

                            <Grid size={6} height={"390px"}>
                                {/* <HoldingPortfolio /> */}

                                <HoldingsListSymbolRealtime
                                    dataReady={isDataReady}
                                    dataRaw={dataPortfolios}
                                    statusMaster={dataMasterTrade?.status ?? ''}
                                    fullWidth={true}
                                />
                            </Grid>

                            <Grid size={6} height={"390px"}>
                                <InvestmentEfficiencyChart
                                    fullWidth={true}
                                    accountId={refaccount}
                                    cosrole={cosrole}
                                    masterAccount={masterAccount}
                                    isPrivate={true}
                                />
                            </Grid>


                            <Grid size={6} height={"390px"}>
                                <ProfitLossHistoryChart
                                    fullWidth={true}
                                    accountId={refaccount}
                                    cosrole={cosrole}
                                    masterAccount={masterAccount}
                                    isPrivate={true}
                                />
                            </Grid>

                            {/* <Grid size={6} height={"390px"}>
                                    <CopyStatisticsChart
                                        fullWidth={true}
                                        accountId={masterAccount}
                                    />
                                </Grid>

                                <Grid size={6} height={"390px"}>
                                    <MasterPointChart
                                        accountId={masterAccount}
                                    />
                                </Grid> */}
                        </Grid>
                    </div>


                    {
                        openModalConfig === true && <ConfigCopy
                            open={openModalConfig}
                            handleClose={handleCloseModalConfig}
                            title={''}
                            data={{ dataMasterTrade }}
                        />
                    }

                </div >
            }
        </>
    )
}